// @generated
// THIS FILE WAS AUTOMATICALLY GENERATED AND SHOULD NOT BE EDITED
/* eslint-disable */
import type * as Types from '../../../../__generated-gql-types__/globalTypes';

import { gql } from '@apollo/client';
import {
  ClassCardClassFragmentDoc,
  ClassCardClassSessionFragmentDoc,
} from '../../../classes/__generated-gql-types__/ClassCard.generated';
import { EventCardEventFragmentDoc } from '../../../subscriber/__generated-gql-types__/EventCard.generated';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type UpcomingClassesCarouselCategoryFragment = {
  __typename?: 'Category';
  id: string;
  name: string;
  slug: string;
  goal: Types.GoalName;
};

export type UpcomingClassesCarouselClassFragment = {
  __typename?: 'Class';
  imageLink?: string | null;
  slug?: string | null;
  price?: number | null;
  durationInMinute?: number | null;
  maximumAttendees?: number | null;
  isUserOnDiscoveryList?: boolean | null;
  isFreeEvent?: boolean | null;
  classId: string;
  className?: string | null;
  upcomingSessionsV2?: Array<{
    __typename?: 'CoachingSession';
    id: string;
    startAt: number;
    totalAttendees: number;
    userIsEnrolled?: boolean | null;
    topFacePiles: Array<string>;
  }> | null;
  category?: { __typename?: 'Category'; id: string; slug: string } | null;
  coach?: {
    __typename?: 'Coach';
    id: string;
    slug: string;
    averageReviewRate: number;
    reviewTotal: number;
    user: {
      __typename?: 'User';
      firstName: string;
      lastName: string;
      id: string;
      pictureLink?: string | null;
    };
    coachingRelationship?: {
      __typename?: 'CoachingRelationship';
      id: string;
      blockedByCoach: boolean;
    } | null;
    categoryInformationList?: Array<{
      __typename?: 'CategoryInformation';
      category: { __typename?: 'Category'; id: string; slug: string };
    }> | null;
  } | null;
};

export type UpcomingClassesCarouselShindigFragment = {
  __typename?: 'Shindig';
  imageLink?: string | null;
  date: number;
  link: string;
  numGuests?: number | null;
  shindigId: string;
  shindigName: string;
  coaches?: Array<{
    __typename?: 'Coach';
    id: string;
    slug: string;
    reviewTotal: number;
    averageReviewRate: number;
    categoryInformationList?: Array<{
      __typename?: 'CategoryInformation';
      category: { __typename?: 'Category'; id: string; slug: string };
    }> | null;
    user: {
      __typename?: 'User';
      id: string;
      pictureLink?: string | null;
      firstName: string;
      lastName: string;
    };
  }> | null;
  categories?: Array<{
    __typename?: 'CategorySelection';
    category: { __typename?: 'Category'; id: string; slug: string };
  }> | null;
  guests?: Array<{ __typename?: 'Guest'; name?: string | null }> | null;
};

export type UpcomingClassesCarouselSearchClassesAndShindigsQueryVariables =
  Types.Exact<{
    categorySlugOrUrnFilter?: Types.InputMaybe<
      Array<Types.Scalars['String']['input']> | Types.Scalars['String']['input']
    >;
    goalFilter?: Types.InputMaybe<Types.GoalName>;
    freeEvent?: Types.InputMaybe<Types.Scalars['Boolean']['input']>;
    start: Types.Scalars['Long']['input'];
    count?: Types.Scalars['Int']['input'];
  }>;

export type UpcomingClassesCarouselSearchClassesAndShindigsQuery = {
  __typename?: 'Query';
  searchClassesAndShindigs: {
    __typename?: 'ClassShindigBatchResponse';
    results: Array<
      | {
          __typename?: 'Class';
          imageLink?: string | null;
          slug?: string | null;
          price?: number | null;
          durationInMinute?: number | null;
          maximumAttendees?: number | null;
          isUserOnDiscoveryList?: boolean | null;
          isFreeEvent?: boolean | null;
          classId: string;
          className?: string | null;
          upcomingSessionsV2?: Array<{
            __typename?: 'CoachingSession';
            id: string;
            startAt: number;
            totalAttendees: number;
            userIsEnrolled?: boolean | null;
            topFacePiles: Array<string>;
          }> | null;
          category?: {
            __typename?: 'Category';
            id: string;
            slug: string;
          } | null;
          coach?: {
            __typename?: 'Coach';
            id: string;
            slug: string;
            averageReviewRate: number;
            reviewTotal: number;
            user: {
              __typename?: 'User';
              firstName: string;
              lastName: string;
              id: string;
              pictureLink?: string | null;
            };
            coachingRelationship?: {
              __typename?: 'CoachingRelationship';
              id: string;
              blockedByCoach: boolean;
            } | null;
            categoryInformationList?: Array<{
              __typename?: 'CategoryInformation';
              category: { __typename?: 'Category'; id: string; slug: string };
            }> | null;
          } | null;
        }
      | {
          __typename?: 'Shindig';
          imageLink?: string | null;
          date: number;
          link: string;
          numGuests?: number | null;
          shindigId: string;
          shindigName: string;
          coaches?: Array<{
            __typename?: 'Coach';
            id: string;
            slug: string;
            reviewTotal: number;
            averageReviewRate: number;
            categoryInformationList?: Array<{
              __typename?: 'CategoryInformation';
              category: { __typename?: 'Category'; id: string; slug: string };
            }> | null;
            user: {
              __typename?: 'User';
              id: string;
              pictureLink?: string | null;
              firstName: string;
              lastName: string;
            };
          }> | null;
          categories?: Array<{
            __typename?: 'CategorySelection';
            category: { __typename?: 'Category'; id: string; slug: string };
          }> | null;
          guests?: Array<{ __typename?: 'Guest'; name?: string | null }> | null;
        }
    >;
  };
};

export const UpcomingClassesCarouselCategoryFragmentDoc = gql`
  fragment UpcomingClassesCarousel_Category on Category {
    id
    name
    slug
    goal
  }
`;
export const UpcomingClassesCarouselClassFragmentDoc = gql`
  fragment UpcomingClassesCarousel_Class on Class {
    classId: id
    ...ClassCard_Class
    upcomingSessionsV2(ignoreFullSessions: true) {
      id
      ...ClassCard_ClassSession
    }
  }
  ${ClassCardClassFragmentDoc}
  ${ClassCardClassSessionFragmentDoc}
`;
export const UpcomingClassesCarouselShindigFragmentDoc = gql`
  fragment UpcomingClassesCarousel_Shindig on Shindig {
    shindigId: id
    ...EventCard_Event
  }
  ${EventCardEventFragmentDoc}
`;
export const UpcomingClassesCarouselSearchClassesAndShindigsDocument = gql`
  query UpcomingClassesCarousel_SearchClassesAndShindigs(
    $categorySlugOrUrnFilter: [String!]
    $goalFilter: GoalName
    $freeEvent: Boolean
    $start: Long!
    $count: Int! = 10
  ) {
    searchClassesAndShindigs(
      categorySlugOrUrnFilter: $categorySlugOrUrnFilter
      goalFilter: $goalFilter
      freeEvent: $freeEvent
      start: $start
      count: $count
    ) {
      results {
        ...UpcomingClassesCarousel_Class
        ...UpcomingClassesCarousel_Shindig
      }
    }
  }
  ${UpcomingClassesCarouselClassFragmentDoc}
  ${UpcomingClassesCarouselShindigFragmentDoc}
`;

/**
 * __useUpcomingClassesCarouselSearchClassesAndShindigsQuery__
 *
 * To run a query within a React component, call `useUpcomingClassesCarouselSearchClassesAndShindigsQuery` and pass it any options that fit your needs.
 * When your component renders, `useUpcomingClassesCarouselSearchClassesAndShindigsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useUpcomingClassesCarouselSearchClassesAndShindigsQuery({
 *   variables: {
 *      categorySlugOrUrnFilter: // value for 'categorySlugOrUrnFilter'
 *      goalFilter: // value for 'goalFilter'
 *      freeEvent: // value for 'freeEvent'
 *      start: // value for 'start'
 *      count: // value for 'count'
 *   },
 * });
 */
export function useUpcomingClassesCarouselSearchClassesAndShindigsQuery(
  baseOptions: Apollo.QueryHookOptions<
    UpcomingClassesCarouselSearchClassesAndShindigsQuery,
    UpcomingClassesCarouselSearchClassesAndShindigsQueryVariables
  > &
    (
      | {
          variables: UpcomingClassesCarouselSearchClassesAndShindigsQueryVariables;
          skip?: boolean;
        }
      | { skip: boolean }
    ),
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useQuery<
    UpcomingClassesCarouselSearchClassesAndShindigsQuery,
    UpcomingClassesCarouselSearchClassesAndShindigsQueryVariables
  >(UpcomingClassesCarouselSearchClassesAndShindigsDocument, options);
}
export function useUpcomingClassesCarouselSearchClassesAndShindigsLazyQuery(
  baseOptions?: Apollo.LazyQueryHookOptions<
    UpcomingClassesCarouselSearchClassesAndShindigsQuery,
    UpcomingClassesCarouselSearchClassesAndShindigsQueryVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useLazyQuery<
    UpcomingClassesCarouselSearchClassesAndShindigsQuery,
    UpcomingClassesCarouselSearchClassesAndShindigsQueryVariables
  >(UpcomingClassesCarouselSearchClassesAndShindigsDocument, options);
}
export function useUpcomingClassesCarouselSearchClassesAndShindigsSuspenseQuery(
  baseOptions?:
    | Apollo.SkipToken
    | Apollo.SuspenseQueryHookOptions<
        UpcomingClassesCarouselSearchClassesAndShindigsQuery,
        UpcomingClassesCarouselSearchClassesAndShindigsQueryVariables
      >,
) {
  const options =
    baseOptions === Apollo.skipToken
      ? baseOptions
      : { ...defaultOptions, ...baseOptions };
  return Apollo.useSuspenseQuery<
    UpcomingClassesCarouselSearchClassesAndShindigsQuery,
    UpcomingClassesCarouselSearchClassesAndShindigsQueryVariables
  >(UpcomingClassesCarouselSearchClassesAndShindigsDocument, options);
}
export type UpcomingClassesCarouselSearchClassesAndShindigsQueryHookResult =
  ReturnType<typeof useUpcomingClassesCarouselSearchClassesAndShindigsQuery>;
export type UpcomingClassesCarouselSearchClassesAndShindigsLazyQueryHookResult =
  ReturnType<
    typeof useUpcomingClassesCarouselSearchClassesAndShindigsLazyQuery
  >;
export type UpcomingClassesCarouselSearchClassesAndShindigsSuspenseQueryHookResult =
  ReturnType<
    typeof useUpcomingClassesCarouselSearchClassesAndShindigsSuspenseQuery
  >;
export type UpcomingClassesCarouselSearchClassesAndShindigsQueryResult =
  Apollo.QueryResult<
    UpcomingClassesCarouselSearchClassesAndShindigsQuery,
    UpcomingClassesCarouselSearchClassesAndShindigsQueryVariables
  >;
